import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function ReportMonitor() {
  const [status, setStatus] = useState(null);
  const [lastCheck, setLastCheck] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get('/api/agents/report-monitor/status')
      .then(r => setStatus(r.data));
  }, []);

  const runCheck = async () => {
    setLoading(true);
    try {
      const r = await axios.post('/api/agents/report-monitor/check');
      setLastCheck(r.data);
    } finally {
      setLoading(false);
    }
  };

  const period = () => {
    const h = new Date().getHours();
    return (h < 12 || (h === 12 && new Date().getMinutes() <= 30))
      ? 'утренний' : 'вечерний';
  };

  return (
    <div>
      <div className="page-header" style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
        <div>
          <div className="page-title">Мониторинг отчётов</div>
          <div className="page-subtitle">
            Проверка ежедневных отчётов в чате Bitrix24 «Управляющие»
          </div>
        </div>
        <button
          className="btn btn-primary"
          onClick={runCheck}
          disabled={loading}
        >
          {loading ? 'Проверяем...' : '▶ Запустить проверку'}
        </button>
      </div>

      {/* Расписание */}
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-value" style={{fontSize:18}}>12:30</div>
          <div className="metric-label">Дедлайн утреннего отчёта</div>
        </div>
        <div className="metric-card">
          <div className="metric-value" style={{fontSize:18}}>23:00</div>
          <div className="metric-label">Дедлайн вечернего отчёта</div>
        </div>
        <div className="metric-card success">
          <div className="metric-value">20</div>
          <div className="metric-label">Должны сдавать отчёт</div>
        </div>
        <div className="metric-card">
          <div className="metric-value" style={{fontSize:14, color:'#6366F1'}}>
            {period()} период
          </div>
          <div className="metric-label">Текущий период</div>
        </div>
      </div>

      {/* Расписание следующих запусков */}
      {status?.schedule && (
        <div className="card">
          <div className="card-title">Расписание</div>
          <table className="table">
            <thead>
              <tr>
                <th>Проверка</th>
                <th>Следующий запуск</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {status.schedule.map(s => (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>{new Date(s.next_run).toLocaleString('ru')}</td>
                  <td><span className="badge badge-success">● Активно</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Результат последней проверки */}
      {lastCheck && (
        <div className="card">
          <div className="card-title">
            Результат проверки —
            {lastCheck.status === 'all_reported'
              ? ' ✅ Все сдали'
              : ` ⚠️ Не сдали ${Object.keys(lastCheck.not_reported || {}).length} из ${lastCheck.total_required}`
            }
          </div>

          {lastCheck.status === 'all_reported' ? (
            <div style={{color:'#10B981', padding:'16px 0'}}>
              Все {lastCheck.reported_count} сотрудников сдали {lastCheck.period === 'morning' ? 'утренний' : 'вечерний'} отчёт ✅
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Сотрудник</th>
                  <th>Статус</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(lastCheck.not_reported || {}).map(([id, name]) => (
                  <tr key={id}>
                    <td>{name}</td>
                    <td><span className="badge badge-danger">Не сдал</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
